<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : '#000'" :class="[`${prefix}-icon`, `${prefix}-icon-delete-folder`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M17.342 5c.647 0 1.261.312 1.676.85L21.44 9h22.115C44.906 9 46 10.015 46 11.267v29.466C46 41.985 44.906 43 43.556 43H4.444C3.094 43 2 41.985 2 40.733V7.363C2 6.059 2.977 5 4.182 5h13.16zM42 13H6v26h36V13zM31 24a1 1 0 011 1v2a1 1 0 01-1 1H17a1 1 0 01-1-1v-2a1 1 0 011-1h14z"/></svg>
</template>
<script>

export default {
  name: 'IconDeleteFolder',
  props: {
    prefix: {
        type: String,
        default: 'arco',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
